<template>
  <v-app v-if="isLoggedIn">
    <div class="btn">
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="red"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-layout row class="tool-bar-tab" color="primary" v-if="isDataLoaded">
      <div class="btn">
        <v-snackbar
          v-model="snackbar_move"
          :left="x === 'left'"
          :multi-line="mode === 'multi-line'"
          :timeout="timeout"
          color="black"
          :top="y === 'top'"
        >
          {{ moving_message }}
          <v-btn color="pink" flat @click="snackbar_move = false">Close</v-btn>
        </v-snackbar>
      </div>
      <v-toolbar class="project mt-2">
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat class="white--text" @click="back()">Edit project</v-btn>
          <v-btn
            flat
            class="white--text"
            v-if="getProjectType() == 2"
            @click="locationPage()"
          >
            Edit Location
          </v-btn>
          <v-btn flat class="white--text" @click="assignTeamToProject()">
            Edit Assign Team To Project
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-layout>
    <v-dialog v-model="dialog2" persistent max-width="600px">
      <copy-question-from-projects @selectQuestion="onclickCopyQuestions" />
    </v-dialog>
    <v-layout>
      <v-flex xs12 sm3>
        <v-container grid-list-md>
          <v-card class="grey lighten-3">
            <v-card-title class="project">
              <div>
                <span class="headline">Questions List</span>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout class="previous d-block">
                <v-list class="d-block scrollable">
                  <draggable
                    v-model="questionData.questions"
                    group="people"
                    :move="checkMove"
                  >
                    <v-list-tile
                      v-for="(element, indexTest) in questionData.questions"
                      :key="indexTest"
                      avatar
                      @click="listData(indexTest)"
                      :class="getClass(indexTest)"
                    >
                      <v-list-tile-action>
                        <!-- <v-icon >star</v-icon> -->
                        <span class="material-icons" color="#11111">list</span>
                      </v-list-tile-action>

                      <v-list-tile-content
                        v-if="getLanguage() == '1' || getLanguage() == '3'"
                      >
                        <v-list-tile-title
                          v-text="
                            questionNameForList(element.question, indexTest)
                          "
                        >
                          {{ indexTest }}
                        </v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-content v-else>
                        <v-list-tile-title
                          v-text="
                            questionNameForList(
                              element.question_bangla,
                              indexTest
                            )
                          "
                        >
                          {{ indexTest }}
                        </v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <!-- <v-icon >star</v-icon> -->
                        <span
                          class="material-icons"
                          v-if="indexTest != 0"
                          @click="deleteQuestion(indexTest)"
                          color="#11111"
                        >
                          delete
                        </span>
                      </v-list-tile-action>
                    </v-list-tile>
                  </draggable>
                </v-list>
              </v-layout>
              <v-spacer></v-spacer>
              <v-layout
                v-if="
                  maximumAllowedQuestionNumber > questionData.questions.length
                "
              >
                <v-icon class="icon" @click="addQuestion">add_circle</v-icon>
                <button>Add Question</button>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex xs12 sm6>
        <v-container grid-list-md>
          <v-card class="grey lighten-3">
            <v-card-title class="project">
              <div>
                <span class="headline">Questions Setup</span>
              </div>
              <div class="red--text headline ml-2">
                <v-btn
                  color="white darken-1"
                  small
                  dark
                  class="no-upercase red--text"
                  @click="copyQuestionsFromProject($event)"
                >
                  Copy Questions from project
                </v-btn>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout
                v-if="
                  allowedNumberOfQuestionPerSurvey() >
                  questionData.questions.length
                "
              >
                <v-icon class="icon" @click="addQuestion">add_circle</v-icon>
                <button>Add Question</button>
              </v-layout>

              <v-form ref="form" lazy-validation>
                <v-layout class="previous d-block">
                  <v-card class="question-layout" justify-space-around>
                    <v-card-title class="project">
                      <span class="headline" for="duration">
                        {{ activeIndex + 1 }}.Question
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex
                            xs12
                            sm6
                            md12
                            v-if="getLanguage() == '1' || getLanguage() == '3'"
                          >
                            <v-text-field
                              v-model.lazy="
                                questionData.questions[activeIndex].question
                              "
                              box
                              label="Question English"
                              :rules="[
                                (v) => !!v || 'Question English is required!',
                              ]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex
                            xs12
                            sm6
                            md12
                            v-if="getLanguage() == '2' || getLanguage() == '3'"
                          >
                            <v-text-field
                              v-model.lazy="
                                questionData.questions[activeIndex]
                                  .question_bangla
                              "
                              box
                              @keypress="isLetter($event)"
                              label="Question Bangla"
                              :rules="[
                                (v) => !!v || 'Question Bangla is required!',
                              ]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md12>
                            <v-select
                              v-model.lazy="
                                questionData.questions[activeIndex]
                                  .ui_category_id
                              "
                              :items="indexData.uiCategories"
                              item-text="name"
                              item-value="id"
                              @change="calculatedPrice($event, activeIndex)"
                              outline
                              label="Choose Question Type"
                              :rules="[
                                (v) => !!v || 'Question Type is required!',
                              ]"
                            ></v-select>
                          </v-flex>
                        </v-layout>

                        <!-- this is dynamic field in question module -->
                        <div
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 1
                          "
                        >
                          <v-layout>
                            <v-flex
                              xs6
                              v-if="
                                getLanguage() == '1' || getLanguage() == '3'
                              "
                            >
                              <v-radio-group>
                                <v-layout
                                  class="previous"
                                  v-for="(radio, index) in questionData
                                    .questions[activeIndex].radios"
                                  v-bind:key="index"
                                >
                                  <v-radio class="shrink mr-2"></v-radio>
                                  <v-text-field
                                    v-model.lazy="radio.title"
                                    :rules="[
                                      (v) => !!v || 'Option name is required!',
                                    ]"
                                  ></v-text-field>
                                  <v-flex xs2>
                                    <v-icon
                                      v-if="index != 0 && getLanguage() == '1'"
                                      @click="deleteOption(activeIndex, index)"
                                    >
                                      clear
                                    </v-icon>
                                    <v-icon
                                      v-if="index != 0 && getLanguage() == '3'"
                                      @click="
                                        deleteBothOption(activeIndex, index)
                                      "
                                    >
                                      clear
                                    </v-icon>
                                  </v-flex>
                                </v-layout>
                              </v-radio-group>
                              <v-layout v-if="getLanguage() == '1'">
                                <v-icon @click="addOption(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add option
                              </v-layout>
                              <v-layout v-if="getLanguage() == '3'">
                                <v-icon @click="addBothOption(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add option
                              </v-layout>
                            </v-flex>
                            <v-flex
                              xs6
                              v-if="
                                getLanguage() == '2' || getLanguage() == '3'
                              "
                            >
                              <v-radio-group>
                                <v-layout
                                  class="previous"
                                  v-for="(
                                    radio_bangla, index_bangla
                                  ) in questionData.questions[activeIndex]
                                    .radios_bangla"
                                  v-bind:key="index_bangla"
                                >
                                  <v-radio class="shrink mr-2"></v-radio>
                                  <v-text-field
                                    v-model.lazy="radio_bangla.title"
                                    :rules="[
                                      (v) =>
                                        !!v ||
                                        'Option Bangla name is required!',
                                    ]"
                                    @keypress="isLetter($event)"
                                  ></v-text-field>
                                  <v-flex xs2>
                                    <v-icon
                                      v-if="
                                        index_bangla != 0 &&
                                        getLanguage() == '2'
                                      "
                                      @click="
                                        deleteOptionBangla(
                                          activeIndex,
                                          index_bangla
                                        )
                                      "
                                    >
                                      clear
                                    </v-icon>
                                  </v-flex>
                                </v-layout>
                              </v-radio-group>
                              <v-layout v-if="getLanguage() == '2'">
                                <v-icon @click="addOptionBangla(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add অপশন
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </div>

                        <div
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 2
                          "
                          align-center
                        >
                          <v-layout>
                            <v-flex
                              xs6
                              v-if="
                                getLanguage() == '1' || getLanguage() == '3'
                              "
                            >
                              <v-layout
                                class="previous"
                                v-for="(checkbox, index) in questionData
                                  .questions[activeIndex].checkboxes"
                                v-bind:key="index"
                              >
                                <v-checkbox class="shrink mr-2"></v-checkbox>
                                <v-text-field
                                  v-model.lazy="checkbox.title"
                                  :rules="[
                                    (v) => !!v || 'Option name is required!',
                                  ]"
                                ></v-text-field>
                                <v-flex xs2>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == '1'"
                                    @click="deleteCheckbox(activeIndex, index)"
                                  >
                                    clear
                                  </v-icon>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == '3'"
                                    @click="
                                      deleteBothCheckbox(activeIndex, index)
                                    "
                                  >
                                    clear
                                  </v-icon>
                                </v-flex>
                              </v-layout>
                              <v-layout v-if="getLanguage() == '1'">
                                <v-icon @click="addCheckbox(activeIndex)">
                                  check_box_outline_blank
                                </v-icon>
                                Add option
                              </v-layout>
                              <v-layout v-if="getLanguage() == '3'">
                                <v-icon @click="addBothCheckbox(activeIndex)">
                                  check_box_outline_blank
                                </v-icon>
                                Add option
                              </v-layout>
                            </v-flex>
                            <v-flex
                              xs6
                              v-if="
                                getLanguage() == '2' || getLanguage() == '3'
                              "
                            >
                              <v-layout
                                class="previous"
                                v-for="(checkbox_bangla, index) in questionData
                                  .questions[activeIndex].checkboxes_bangla"
                                v-bind:key="index"
                              >
                                <v-checkbox class="shrink mr-2"></v-checkbox>
                                <v-text-field
                                  v-model.lazy="checkbox_bangla.title"
                                  :rules="[
                                    (v) =>
                                      !!v || 'Option Bangla name is required!',
                                  ]"
                                  @keypress="isLetter($event)"
                                ></v-text-field>
                                <v-flex xs2>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == '2'"
                                    @click="
                                      deleteCheckboxBangla(activeIndex, index)
                                    "
                                  >
                                    clear
                                  </v-icon>
                                </v-flex>
                              </v-layout>
                              <v-layout v-if="getLanguage() == '2'">
                                <v-icon @click="addCheckboxBangla(activeIndex)">
                                  check_box_outline_blank
                                </v-icon>
                                Add অপশন
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </div>

                        <div
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 4
                          "
                          align-center
                        >
                          <v-layout>
                            <v-flex
                              xs6
                              v-if="
                                getLanguage() == '1' || getLanguage() == '3'
                              "
                            >
                              <v-layout
                                class="previous"
                                v-for="(dropdown, index) in questionData
                                  .questions[activeIndex].dropdowns"
                                v-bind:key="index"
                              >
                                <v-text-field
                                  v-model.lazy="dropdown.title"
                                  :rules="[
                                    (v) => !!v || 'Option name is required!',
                                  ]"
                                ></v-text-field>
                                <v-flex xs2>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == '1'"
                                    @click="deleteDropDown(activeIndex, index)"
                                  >
                                    clear
                                  </v-icon>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == '3'"
                                    @click="
                                      deleteBothDropDown(activeIndex, index)
                                    "
                                  >
                                    clear
                                  </v-icon>
                                </v-flex>
                              </v-layout>
                              <v-layout v-if="getLanguage() == '1'">
                                <v-icon @click="addDropDown(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add option
                              </v-layout>
                              <v-layout v-if="getLanguage() == '3'">
                                <v-icon @click="addBothDropDown(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add option
                              </v-layout>
                            </v-flex>
                            <v-flex
                              xs6
                              v-if="
                                getLanguage() == '2' || getLanguage() == '3'
                              "
                            >
                              <v-layout
                                class="previous"
                                v-for="(dropdown_bangla, index) in questionData
                                  .questions[activeIndex].dropdowns_bangla"
                                v-bind:key="index"
                              >
                                <v-text-field
                                  v-model.lazy="dropdown_bangla.title"
                                  :rules="[
                                    (v) =>
                                      !!v || 'Option Bangla name is required!',
                                  ]"
                                  @keypress="isLetter($event)"
                                ></v-text-field>
                                <v-flex xs2>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == '2'"
                                    @click="
                                      deleteDropDownBangla(activeIndex, index)
                                    "
                                  >
                                    clear
                                  </v-icon>
                                </v-flex>
                              </v-layout>
                              <v-layout v-if="getLanguage() == '2'">
                                <v-icon @click="addDropDownBangla(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add অপশন
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </div>

                        <v-layout
                          v-bind="binding"
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 5
                          "
                        >
                          <OpenEnded
                            :openEndedInfo="
                              questionData.questions[activeIndex].openEnded
                            "
                            @change="onOpenEndedValidation($event, activeIndex)"
                          />
                        </v-layout>

                        <v-layout
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 6
                          "
                          row
                        >
                          <v-flex xs4>
                            <v-text-field
                              label="Min"
                              v-model.lazy="
                                questionData.questions[activeIndex].range.min
                              "
                              :rules="[(v) => !!v || 'Min value is required!']"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                              label="Max"
                              v-model.lazy="
                                questionData.questions[activeIndex].range.max
                              "
                              :rules="[(v) => !!v || 'Max name is required!']"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout
                          v-bind="binding"
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 7
                          "
                        >
                          <v-flex xs12>
                            <v-slider
                              disabled
                              label="Slider"
                              inverse-label
                              value="30"
                            ></v-slider>
                          </v-flex>
                          <v-layout row>
                            <v-flex xs4>
                              <v-text-field
                                label="Min"
                                v-model.lazy="
                                  questionData.questions[activeIndex].slider.min
                                "
                                :rules="[
                                  (v) => !!v || 'Min value name is required!',
                                ]"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                label="Max"
                                v-model.lazy="
                                  questionData.questions[activeIndex].slider.max
                                "
                                :rules="[
                                  (v) => !!v || 'Max value is required!',
                                ]"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                label="Interval"
                                v-model.lazy="
                                  questionData.questions[activeIndex].slider
                                    .interval
                                "
                                :rules="[
                                  (v) => !!v || 'Interval value is required!',
                                ]"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-layout>

                        <v-layout
                          v-bind="binding"
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 8
                          "
                        >
                          <v-flex xs12>
                            <v-rating disabled label="Rating"></v-rating>
                          </v-flex>
                          <v-layout row>
                            <v-flex xs6>
                              <v-text-field
                                label="Min"
                                v-model.lazy="
                                  questionData.questions[activeIndex].starRating
                                    .min
                                "
                                :rules="[
                                  (v) => !!v || 'Min value is required!',
                                ]"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                label="Max"
                                v-model.lazy="
                                  questionData.questions[activeIndex].starRating
                                    .max
                                "
                                :rules="[
                                  (v) => !!v || 'Max value is required!',
                                ]"
                              ></v-text-field>
                            </v-flex>
                            <!-- <v-flex xs4>
                              <v-text-field
                                label="Interval"
                                v-model.lazy="questionData.questions[activeIndex].starRating.interval"
                              ></v-text-field>
                            </v-flex> -->
                          </v-layout>
                        </v-layout>

                        <v-layout
                          align-center
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 9
                          "
                          row
                        >
                          <v-icon>insert_photo</v-icon>
                          <v-text-field
                            box
                            disabled
                            label="Image"
                          ></v-text-field>
                        </v-layout>

                        <v-layout
                          align-center
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 10
                          "
                          row
                        >
                          <v-icon>audiotrack</v-icon>
                          <v-text-field
                            box
                            disabled
                            label="Audio"
                          ></v-text-field>
                        </v-layout>

                        <v-layout
                          align-center
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 11
                          "
                          row
                        >
                          <v-icon>video_library</v-icon>
                          <v-text-field
                            box
                            disabled
                            label="Video"
                          ></v-text-field>
                        </v-layout>

                        <v-layout
                          v-bind="binding"
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 12
                          "
                        >
                          <DateTime
                            :dateInfo="
                              questionData.questions[activeIndex].date_time
                            "
                            @change="onDateChange($event, activeIndex)"
                          />
                        </v-layout>

                        <v-layout
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 13
                          "
                          row
                        >
                          <v-icon>place</v-icon>
                          <v-text-field
                            box
                            disabled
                            label="Location"
                          ></v-text-field>
                        </v-layout>

                        <div
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 14
                          "
                        >
                          <v-layout
                            row
                            v-for="(image, index) in questionData.questions[
                              activeIndex
                            ].images"
                            v-bind:key="index"
                          >
                            <v-flex xs12 sm6>
                              <v-container fluid grid-list-lg>
                                <v-layout row wrap>
                                  <v-flex xs6>
                                    <image-upload2
                                      :imageUrl="image.url"
                                      :imageBaseUrl="indexData.quesImageUrl"
                                      @change="
                                        onImageChange(
                                          $event,
                                          activeIndex,
                                          index
                                        )
                                      "
                                      select-text="Select Image"
                                    />
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-text-field
                                      v-model.lazy="image.name"
                                      label="Image name"
                                      @keypress="isLetterForImage($event)"
                                      :rules="[
                                        (event) =>
                                          imageValidationCheck(
                                            event,
                                            activeIndex,
                                            index
                                          ),
                                        rules.required,
                                      ]"
                                    ></v-text-field>
                                  </v-flex>
                                  <div v-if="index > -1">
                                    <v-icon
                                      @click="deleteImage(activeIndex, index)"
                                      color="black"
                                    >
                                      cancel
                                    </v-icon>
                                  </div>
                                </v-layout>
                              </v-container>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex>
                              <v-btn
                                color="success"
                                class="i_button"
                                @click="addImage(activeIndex)"
                              >
                                Add option
                                <v-icon color="black" right>
                                  add_circle_outline
                                </v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>

                        <v-layout
                          wrap
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 15
                          "
                        >
                          <v-layout
                            v-if="
                              questionData.questions[activeIndex].error_message
                            "
                            class="red--text"
                          >
                            This field can't be empty
                          </v-layout>
                          <ContactInfo
                            :contactInfo="
                              questionData.questions[activeIndex].contactInfo
                            "
                            @change="contactInfo($event, activeIndex)"
                          />
                        </v-layout>

                        <v-layout
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 16
                          "
                          row
                        >
                          <v-icon>email</v-icon>
                          <v-text-field disabled label="Email"></v-text-field>
                        </v-layout>

                        <v-layout
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 17
                          "
                          row
                        >
                          <v-icon>phone</v-icon>
                          <v-text-field disabled label="Phone"></v-text-field>
                        </v-layout>

                        <v-layout
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 17
                          "
                          row
                        >
                          <v-icon>phone</v-icon>
                          <v-text-field
                            type="number"
                            disabled
                            label="Number"
                          ></v-text-field>
                        </v-layout>

                        <!-- end dynamic field in question module -->
                        <v-divider
                          class="mt-3"
                          v-if="questionData.questions[activeIndex].has_logic"
                        ></v-divider>
                        <v-layout
                          v-if="questionData.questions[activeIndex].has_logic"
                          wrap
                        >
                          <v-flex xs12>
                            <div class="subheader black--text">Logics</div>
                          </v-flex>
                          <v-flex xs12 sm6 md12>
                            <v-card
                              class="white--text"
                              v-for="(
                                logic_group, logic_group_index
                              ) in questionData.questions[activeIndex]
                                .logic_group"
                              v-bind:key="logic_group_index"
                            >
                              <v-card-title
                                class="red--background right"
                                primary-title
                              >
                                <div>
                                  <div class="subheader black--text right">
                                    {{ getGroupName(logic_group_index) }}
                                  </div>
                                </div>
                              </v-card-title>
                              <v-layout row>
                                <v-card-text>
                                  <v-flex
                                    xs12
                                    class="previous"
                                    v-for="(
                                      logic, logic_index
                                    ) in logic_group.logic_set"
                                    v-bind:key="logic_index"
                                  >
                                    <v-layout>
                                      <v-flex xs4>
                                        <v-select
                                          v-model.lazy="logic.q_index"
                                          :items="getQuestionItem(activeIndex)"
                                          item-text="title"
                                          item-value="id"
                                          @change="
                                            filterOperator(
                                              $event,
                                              activeIndex,
                                              logic_group_index,
                                              logic_index
                                            )
                                          "
                                          outline
                                          label="Choose logic question"
                                          :rules="[
                                            (v) =>
                                              !!v ||
                                              'Question Type is required!',
                                          ]"
                                        ></v-select>
                                      </v-flex>
                                      <v-flex xs3>
                                        <v-select
                                          v-model.lazy="logic.logic_operator_id"
                                          :items="logic.logic_operator"
                                          item-text="name"
                                          item-value="id"
                                          outline
                                          label="Choose operator"
                                          :rules="[
                                            (v) =>
                                              !!v || 'This Field is required!',
                                          ]"
                                        ></v-select>
                                      </v-flex>
                                      <v-flex
                                        xs4
                                        v-if="
                                          logic.logic_input_ui_type == 'select'
                                        "
                                      >
                                        <v-select
                                          v-model.lazy="logic.logic_input"
                                          :items="
                                            getLogicInputValue(
                                              activeIndex,
                                              logic_group_index,
                                              logic_index
                                            )
                                          "
                                          item-text="title"
                                          item-value="value"
                                          outline
                                          label="Choose value"
                                          multiple
                                          :rules="[
                                            (v) =>
                                              !!v || 'This Field is required!',
                                          ]"
                                        ></v-select>
                                      </v-flex>
                                      <v-flex
                                        xs4
                                        v-if="
                                          logic.logic_input_ui_type == 'input'
                                        "
                                      >
                                        <v-text-field
                                          type="number"
                                          v-model.lazy="logic.logic_input"
                                          :rules="[
                                            (event) =>
                                              validationCheck(
                                                event,
                                                activeIndex,
                                                logic_group_index,
                                                logic_index
                                              ),
                                            rules.required,
                                          ]"
                                        ></v-text-field>
                                      </v-flex>

                                      <v-flex xs1>
                                        <v-icon
                                          @click="
                                            delete_logic(
                                              activeIndex,
                                              logic_group_index,
                                              logic_index
                                            )
                                          "
                                        >
                                          clear
                                        </v-icon>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-layout row>
                                    <v-flex xs12>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <!-- <v-btn color="primary" dark v-on="on">Button</v-btn> -->
                                          <v-icon
                                            color="primary"
                                            dark
                                            v-on="on"
                                            @click="
                                              addLogic(
                                                activeIndex,
                                                logic_group_index
                                              )
                                            "
                                          >
                                            add_circle_outline
                                          </v-icon>
                                        </template>
                                        <span>add logic</span>
                                      </v-tooltip>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout row>
                                <v-flex xs10 class="right" offset-xs1>
                                  <div>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <!-- <v-btn color="primary" dark v-on="on">Button</v-btn> -->
                                        <v-btn
                                          fab
                                          small
                                          color="red"
                                          class="right"
                                          dark
                                          v-on="on"
                                          v-if="
                                            questionData.questions[activeIndex]
                                              .logic_group[logic_group_index]
                                              .logic_set.length < 1
                                          "
                                          @click="
                                            delete_logic_group(
                                              activeIndex,
                                              logic_group_index
                                            )
                                          "
                                        >
                                          <v-icon dark>close</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Remove group</span>
                                    </v-tooltip>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                            <v-layout row>
                              <v-flex xs12>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <!-- <v-btn color="primary" dark v-on="on">Button</v-btn> -->
                                    <v-btn
                                      fab
                                      small
                                      color="primary"
                                      dark
                                      v-on="on"
                                      @click="addLogicGroup(activeIndex)"
                                    >
                                      <v-icon dark>add_task</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>add group</span>
                                </v-tooltip>
                                <!-- <span @click="addLogicGroup(activeIndex)">add group<v-icon>add_task</v-icon></span> -->
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <!-- start card footer -->
                        <v-divider
                          v-if="questionData.questions[activeIndex].boolean1"
                        ></v-divider>
                        <v-layout
                          v-if="questionData.questions[activeIndex].boolean1"
                          wrap
                        >
                          <v-flex
                            xs12
                            v-if="getLanguage() == '1' || getLanguage() == '3'"
                          >
                            <ckeditor
                              :editor="editor"
                              v-model.lazy="
                                questionData.questions[activeIndex].instruction
                              "
                              label="Instruction"
                              :config="editorConfigInstruction"
                            ></ckeditor>
                          </v-flex>
                          <v-flex
                            xs12
                            v-if="getLanguage() == '2' || getLanguage() == '3'"
                          >
                            <ckeditor
                              :editor="editor"
                              v-model.lazy="
                                questionData.questions[activeIndex]
                                  .instruction_bangla
                              "
                              label="Instruction Bangla"
                              :config="editorConfigInstructionBangla"
                            ></ckeditor>
                          </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout
                          v-if="questionData.questions[activeIndex].boolean2"
                          wrap
                        >
                          <v-flex
                            xs12
                            v-if="getLanguage() == '1' || getLanguage() == '3'"
                          >
                            <ckeditor
                              :editor="editor"
                              v-model.lazy="
                                questionData.questions[activeIndex].description
                              "
                              :config="editorConfig"
                            ></ckeditor>
                          </v-flex>
                          <v-flex
                            xs12
                            v-if="getLanguage() == '2' || getLanguage() == '3'"
                          >
                            <ckeditor
                              :editor="editor"
                              v-model.lazy="
                                questionData.questions[activeIndex]
                                  .description_bangla
                              "
                              label="Description"
                              :config="editorConfig1"
                            ></ckeditor>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-title class="pt-1 pb-1">
                      <span
                        class="material-icons"
                        @click="addQuestion"
                        v-if="
                          maximumAllowedQuestionNumber >
                          questionData.questions.length
                        "
                      >
                        add_circle_outline
                      </span>

                      <v-spacer></v-spacer>
                      <v-switch
                        v-model.lazy="
                          questionData.questions[activeIndex].required_optional
                        "
                        :label="`Required`"
                      ></v-switch>
                      <v-switch
                        v-if="
                          questionData.questions[activeIndex].ui_category_id !=
                            1 &&
                          questionData.questions[activeIndex].ui_category_id !=
                            5 &&
                          questionData.questions[activeIndex].ui_category_id !=
                            6 &&
                          questionData.questions[activeIndex].ui_category_id !=
                            7 &&
                          questionData.questions[activeIndex].ui_category_id !=
                            8 &&
                          questionData.questions[activeIndex].ui_category_id !=
                            12
                        "
                        v-model.lazy="
                          questionData.questions[activeIndex].multiple_answer
                        "
                        :label="`Multiple Answer`"
                      ></v-switch>
                      <v-switch
                        v-if="
                          activeIndex > 0 && hasConditionalQuestionAllowed()
                        "
                        v-model.lazy="
                          questionData.questions[activeIndex].has_logic
                        "
                        :label="`Logic`"
                      ></v-switch>
                      <span
                        class="material-icons"
                        @click="deleteQuestion(activeIndex)"
                      >
                        delete
                      </span>
                      <v-menu offset-x>
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on">
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-tile
                            v-for="(item, i) in items"
                            :key="i"
                            @click="listItem(activeIndex, i)"
                          >
                            <v-list-tile-title>
                              {{ item.title }}
                            </v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-card-title>
                  </v-card>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <button class="button" flat @click="back">Back</button>
              <v-btn class="button" flat @click="submit">Save & next</v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex xs12 sm3>
        <Comment />
      </v-flex>
    </v-layout>
  </v-app>
  <v-layout v-else>
    <Signin class="mt-1"></Signin>
  </v-layout>
</template>

<script>
import OpenEnded from "../components/OpenEnded";
import DateTime from "../components/DateTime";
import ContactInfo from "../components/ContactInfo";
import Comment from "./Comment";
import { ImageUpload2 } from "@/components/index";
import { mapGetters } from "vuex";
import ClassicEditor from "ckeditor5-build-classic-base64-upload";
import draggable from "vuedraggable";
import { CopyQuestionFromProjects } from "@/components/index";
import axios from "axios";
import api from "../../../api/connectingUrls";
import utilities from "../../../api/utilities.js";

export default {
  components: {
    OpenEnded,
    CopyQuestionFromProjects,
    ContactInfo,
    // ImageInsert,
    ImageUpload2,
    DateTime,
    draggable,
    Comment,
  },
  data: () => ({
    apiUrl: "question-json",
    editedIndex: -1,
    dialog2: false,
    dialog: false,
    activeIndex: 0,
    refreshRequest: 0,
    maximumAllowedQuestionNumber: null,
    flag: null,
    //star rating
    length: 5,
    rating: 3,
    readonly: true,
    snackbar: false,
    snackbar_move: false,
    moving_message: "Sorry! Invalid move. Sorry! Invalid move",
    y: "top",
    x: null,
    mode: "multi-line",
    timeout: 4000,
    questionData: {
      current_question_id: 1,
      questions: [
        {
          question: "",
          question_variable: "var1",
          question_bangla: "",
          ui_category_id: "",
          required_optional: "",
          multiple_answer: "",
          instruction: "",
          instruction_bangla: "",
          description: "",
          description_bangla: "",
          error_message: "",
          boolean1: false,
          boolean2: false,
          has_logic: false,
          date_time: "date & time",
          child_variables: [],
          logic_variables: [],
          logic_group: [
            {
              logic_set: [
                {
                  q_index: "",
                  logic_operator_id: "",
                  logic_input: "",
                  logic_condition: "",
                  logic_input_ui_type: "",
                  logic_operator: [],
                },
              ],
            },
          ],
          radios: [
            {
              title: "option1",
              value: 1,
            },
          ],
          radios_bangla: [
            {
              title: "অপশন১",
              value: 1,
            },
          ],
          checkboxes: [
            {
              title: "option1",
              value: 1,
            },
          ],
          checkboxes_bangla: [
            {
              title: "অপশন১",
              value: 1,
            },
          ],
          dropdowns: [
            {
              title: "option1",
              value: 1,
            },
          ],
          dropdowns_bangla: [
            {
              title: "অপশন১",
              value: 1,
            },
          ],
          images: [
            {
              url: "",
              id: "",
              value: 1,
              name: "",
            },
          ],
          range: {
            min: "",
            max: "",
          },
          slider: {
            min: "",
            max: "",
            interval: "",
          },
          starRating: {
            min: 1,
            max: "",
          },
          contactInfo: {
            first_name: true,
            middle_name: true,
            last_name: false,
            phone: true,
            email: true,
            address: false,
          },
          openEnded: {
            text_type: "",
            condition: "",
            conditional_number: "",
            conditional_text: "",
            custom_error: "",
          },
        },
      ],
      project_id: "",
      ui_category_price: [],
      total_category_price: 0,
    },
    defaultItem: {
      question: "",
      question_bangla: "",
      question_variable: "",
      question_type_id: "",
      required_optional: "",
      instruction: "",
      instruction_bangla: "",
      description: "",
      description_bangla: "",
      multiple_answer: "",
    },
    items: [
      { title: "Instruction" },
      { title: "description" },
      // { title: "Instruction_bangla" },
      // { title: "description_bangla" },
      // { title: 'Response validation' },
    ],
    editor: ClassicEditor,
    editorData: "<p>Content of the editor.</p>",
    editorConfig: {
      placeholder: "Type the description here!",
      height: 300,
      minimumCharacters: 5,
    },
    editorConfig1: {
      placeholder: "Type the description Bangla here!",
      height: 300,
      minimumCharacters: 5,
    },
    editorConfigInstruction: {
      placeholder: "Type the instruction here!",
      height: 300,
      minimumCharacters: 5,
    },
    editorConfigInstructionBangla: {
      placeholder: "Type the Bangla instruction here!",
      height: 300,
      minimumCharacters: 5,
    },

    QuestSubmitData: {
      data: [],
    },
    rules: {
      required: (v) => !!v || "this field is required",
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
      "projectId",
    ]),
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },

    isDataLoaded() {
      return this.setQuestionData();
    },
  },

  created() {
    var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
    // console.log(project_id);
    this.questionData.project_id = project_id;
    this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.indexData.project_data) {
        if (this.indexData.project_data.project_question_json !== null) {
          var questions_data_json = JSON.parse(
            this.indexData.project_data.project_question_json
          );
          this.questionData = questions_data_json;
          // console.log(this.questionData);
        }
      }
      this.maximumAllowedQuestionNumber =
        utilities.allowedNumberOfQuestionPerSurvey(
          this.subscriptionData.subscriptionFeatures
        );
    },

    allowedNumberOfQuestionPerSurvey: function () {
      return (this.maximumAllowedQuestionNumber =
        utilities.allowedNumberOfQuestionPerSurvey(
          this.subscriptionData.subscriptionFeatures
        ));
    },

    validationCheck(event, activeIndex, logic_group_index, logic_index) {
      //
      var q_index =
        this.questionData.questions[activeIndex].logic_group[logic_group_index]
          .logic_set[logic_index].q_index;
      var variable_index = this.questionData.questions.findIndex(
        (x) => x.question_variable === q_index
      );
      var ui_category =
        this.questionData.questions[variable_index].ui_category_id;
      var max_value;
      var min_value;
      var event_value = parseInt(event);

      if (ui_category == 6) {
        max_value = parseInt(
          this.questionData.questions[variable_index].range.max
        );
        min_value = parseInt(
          this.questionData.questions[variable_index].range.min
        );
      } else if (ui_category == 7) {
        max_value = parseInt(
          this.questionData.questions[variable_index].slider.max
        );
        min_value = parseInt(
          this.questionData.questions[variable_index].slider.min
        );
      } else if (ui_category == 8) {
        max_value = parseInt(
          this.questionData.questions[variable_index].starRating.max
        );
        min_value = parseInt(
          this.questionData.questions[variable_index].starRating.min
        );
      } else if (ui_category == 18) {
        return true;
      }

      if (!(event_value <= max_value && event_value >= min_value)) {
        return `Value must be between ${min_value} and ${max_value}`;
      } else {
        return true;
      }
    },

    checkMove: function (evt) {
      if (this.flag == null) {
        this.flag = 1;
        //  console.log(test+" flag "+this.flag);
        var response_array = this.haveMove(evt);
        if (response_array.length > 0) {
          this.moving_message =
            "Sorry! Your move is invalid. You have dependency on " +
            response_array.toString();
          this.x = "left";
          this.mode = "single";
          this.snackbar_move = true;
          this.close();
          this.flag = null;
          return false;
        } else {
          this.flag = null;
          return true;
        }
      }
    },

    haveMove(evt) {
      var moving_from_q = "";
      var detected_array = [];
      if (evt.draggedContext.index > evt.draggedContext.futureIndex) {
        if (
          this.questionData.questions[evt.draggedContext.index].has_logic &&
          this.questionData.questions[evt.draggedContext.index].logic_variables
            .length > 0
        ) {
          for (
            var i = evt.draggedContext.futureIndex;
            i < evt.draggedContext.index;
            i++
          ) {
            this.questionData.questions[
              evt.draggedContext.index
            ].logic_variables.forEach((element) => {
              if (
                this.questionData.questions[i].question_variable ===
                element.var_name
              ) {
                var detected_var = "Q" + (i + 1);
                if (detected_array.indexOf(detected_var) < 0) {
                  detected_array.push(detected_var);
                }
              }
            });
          }
        }
        return detected_array;
      } else {
        moving_from_q =
          this.questionData.questions[evt.draggedContext.index]
            .question_variable;
        for (
          i = evt.draggedContext.index + 1;
          i <= evt.draggedContext.futureIndex;
          i++
        ) {
          if (
            this.questionData.questions[i].has_logic &&
            this.questionData.questions[i].logic_variables.length > 0
          ) {
            //
            this.questionData.questions[i].logic_variables.forEach(
              (element) => {
                if (moving_from_q === element.var_name) {
                  var detected_var = "Q" + (i + 1);
                  if (detected_array.indexOf(detected_var) < 0) {
                    detected_array.push(detected_var);
                  }
                }
              }
            );
          }
        }
        return detected_array;
      }
    },

    getClass(indexTest) {
      if (indexTest == this.activeIndex) {
        return "m-b-1 list-color-active";
      } else {
        return "m-b-1";
      }
    },

    getGroupName(group_index) {
      return "Logic group - " + (group_index + 1);
    },

    getLogicInputValue(activeIndex, logic_group_index, logic_index) {
      var q_index =
        this.questionData.questions[activeIndex].logic_group[logic_group_index]
          .logic_set[logic_index].q_index;
      var variable_index = this.questionData.questions.findIndex(
        (x) => x.question_variable === q_index
      );
      var ui_category =
        this.questionData.questions[variable_index].ui_category_id;

      if (ui_category == 1) {
        if (this.getLanguage() == 2) {
          return this.questionData.questions[variable_index].radios_bangla;
        }
        return this.questionData.questions[variable_index].radios;
      } else if (ui_category == 2) {
        if (this.getLanguage() == 2) {
          return this.questionData.questions[variable_index].checkboxes_bangla;
        }
        return this.questionData.questions[variable_index].checkboxes;
      } else if (ui_category == 4) {
        if (this.getLanguage() == 2) {
          return this.questionData.questions[variable_index].dropdowns_bangla;
        }
        return this.questionData.questions[variable_index].dropdowns;
      } else {
        return this.questionData.questions[variable_index].images;
      }
      // console.log(this.questionData.questions[activeIndex].logic_group);
    },

    checkInputType(ui_category_id, activeIndex, logicGroupIndex, logic_index) {
      if (
        ui_category_id == 18 ||
        ui_category_id == 7 ||
        ui_category_id == 8 ||
        ui_category_id == 6
      ) {
        this.questionData.questions[activeIndex].logic_group[
          logicGroupIndex
        ].logic_set[logic_index].logic_input_ui_type = "input";
        return true;
      }
      this.questionData.questions[activeIndex].logic_group[
        logicGroupIndex
      ].logic_set[logic_index].logic_input_ui_type = "select";
      return false;
      // console.log(question_type_data);
    },

    clearDumpVariable(event, activeIndex, logicGroupIndex, logicIndex) {
      var currentIndex = this.questionData.questions[
        activeIndex
      ].logic_variables.findIndex(
        (x) =>
          x.var_name !== event &&
          x.var_logic_group_index === logicGroupIndex &&
          x.var_logic_index === logicIndex
      );
      // console.log(currentIndex);
      if (currentIndex > -1) {
        var removingVariableChild =
          this.questionData.questions[activeIndex].logic_variables[currentIndex]
            .var_name;
        this.clearIfDumpInParent(
          removingVariableChild,
          activeIndex,
          logicGroupIndex,
          logicIndex
        );
        this.questionData.questions[activeIndex].logic_variables.splice(
          currentIndex,
          1
        );
      }
      // console.log(this.questionData.questions[activeIndex].logic_variables);
    },

    clearIfDumpInParent(
      removingVariableChild,
      activeIndex,
      logicGroupIndex,
      logicIndex
    ) {
      var removableVariableIndex = this.questionData.questions.findIndex(
        (x) => x.question_variable === removingVariableChild
      );

      if (
        this.questionData.questions[removableVariableIndex].child_variables
          .length > 0
      ) {
        var currentVariable =
          this.questionData.questions[activeIndex].question_variable;
        var currentIndex = this.questionData.questions[
          removableVariableIndex
        ].child_variables.findIndex(
          (x) =>
            x.var_name === currentVariable &&
            x.var_logic_group_index === logicGroupIndex &&
            x.var_logic_index === logicIndex
        );
        if (currentIndex > -1) {
          this.questionData.questions[
            removableVariableIndex
          ].child_variables.splice(currentIndex, 1);
        }
      }
    },

    filterOperator(event, activeIndex, logicGroupIndex, logic_index) {
      this.questionData.questions[activeIndex].logic_variables.push({
        var_name: event,
        var_logic_group_index: logicGroupIndex,
        var_logic_index: logic_index,
      });

      var variable_index = this.questionData.questions.findIndex(
        (x) => x.question_variable === event
      );
      var ui_category_id =
        this.questionData.questions[variable_index].ui_category_id;

      this.questionData.questions[variable_index].child_variables.push({
        var_name: this.questionData.questions[activeIndex].question_variable,
        var_logic_group_index: logicGroupIndex,
        var_logic_index: logic_index,
      });
      this.clearDumpVariable(event, activeIndex, logicGroupIndex, logic_index);
      var filterValue = [];
      if (
        this.checkInputType(
          ui_category_id,
          activeIndex,
          logicGroupIndex,
          logic_index
        )
      ) {
        for (let i = 0; i < this.indexData.operators.length; i++) {
          if (
            this.indexData.operators[i].id != 6 &&
            this.indexData.operators[i].id != 7
          ) {
            filterValue.push(this.indexData.operators[i]);
          }
        }
      } else {
        for (let i = 0; i < this.indexData.operators.length; i++) {
          if (
            this.indexData.operators[i].id == 6 ||
            this.indexData.operators[i].id == 7
          ) {
            filterValue.push(this.indexData.operators[i]);
          }
        }
      }
      this.questionData.questions[activeIndex].logic_group[
        logicGroupIndex
      ].logic_set[logic_index].logic_operator = filterValue;
    },

    addLogic(activeIndex, logicGroupIndex) {
      this.questionData.questions[activeIndex].logic_group[
        logicGroupIndex
      ].logic_set.push({
        q_index: "",
        logic_operator_id: "",
        logic_input: "",
        logic_condition: "",
        logic_input_ui_type: "",
        logic_operator: [],
      });
      // console.log(this.questionData.questions[activeIndex].logic_group);
    },

    addLogicGroup(activeIndex) {
      this.questionData.questions[activeIndex].logic_group.push({
        logic_set: [
          {
            q_index: "",
            logic_operator_id: "",
            logic_input: "",
            logic_condition: "",
            logic_input_ui_type: "",
            logic_operator: [],
          },
        ],
      });
    },

    delete_logic(activeIndex, logic_group_index, logic_index) {
      // console.log(activeIndex +" "+ logic_index);
      var logicVariableData =
        this.questionData.questions[activeIndex].logic_group[logic_group_index]
          .logic_set[logic_index].q_index;
      if (logicVariableData !== "") {
        var current_index = this.questionData.questions[
          activeIndex
        ].logic_variables.findIndex(
          (x) =>
            x.var_name === logicVariableData &&
            x.var_logic_group_index === logic_group_index &&
            x.var_logic_index === logic_index
        );
        // console.log(current_index);
        this.questionData.questions[activeIndex].logic_variables.splice(
          current_index,
          1
        );
      }

      this.questionData.questions[activeIndex].logic_group[
        logic_group_index
      ].logic_set.splice(logic_index, 1);
    },

    delete_logic_group(activeIndex, logic_group_index) {
      this.questionData.questions[activeIndex].logic_group.splice(
        logic_group_index,
        1
      );
    },

    getQuestionItem(activeIndex) {
      // console.log(activeIndex);
      var question_array = [];
      var ui_category_array = [1, 2, 4, 6, 7, 8, 14, 18];
      for (var index = 0; index < this.questionData.questions.length; index++) {
        if (
          activeIndex > index &&
          ui_category_array.includes(
            this.questionData.questions[index].ui_category_id
          )
        ) {
          question_array.push({
            id: this.questionData.questions[index].question_variable,
            title: this.questionData.questions[index].question,
          });
        }
      }
      return question_array;
    },

    getLanguage() {
      if (this.indexData.project_data) {
        return this.indexData.project_data.project_language;
      } else {
        return "";
      }
    },

    getProjectType() {
      if (this.indexData.project_data) {
        if (this.indexData.project_data.project_type_id) {
          return this.indexData.project_data.project_type_id;
        }
      }
      return false;
    },

    setQuestionData() {
      // this.questionData.project_id = project_id;
      if (this.refreshRequest == "0") {
        this.$store.dispatch("indexData", [
          this.apiUrl,
          this.questionData.project_id,
        ]);
        this.refreshRequest = 1;
      }
      if (this.indexData.project_data) {
        if (this.indexData.project_data.project_question_json !== null) {
          var questions_data_json = JSON.parse(
            this.indexData.project_data.project_question_json
          );
          this.questionData = questions_data_json;
          // console.log(this.questionData);
        }
      }
      return true;
    },

    listData(indexTest) {
      this.activeIndex = indexTest;
      // console.log(this.questionData.questions[indexTest]);
    },

    questionNameForList(questionName, IndexOfQuestion) {
      return "Q" + (IndexOfQuestion + 1) + " " + questionName;
    },

    addQuestion() {
      this.questionData.questions.push({
        question: "",
        question_variable: "var1",
        question_bangla: "",
        ui_category_id: "",
        required_optional: "",
        multiple_answer: "",
        instruction: "",
        instruction_bangla: "",
        description: "",
        description_bangla: "",
        error_message: "",
        boolean1: false,
        boolean2: false,
        has_logic: false,
        date_time: "date & time",
        child_variables: [],
        logic_variables: [],
        logic_group: [
          {
            logic_set: [
              {
                q_index: "",
                logic_operator_id: "",
                logic_input: "",
                logic_condition: "",
                logic_input_ui_type: "",
                logic_operator: [],
              },
            ],
          },
        ],
        radios: [
          {
            title: "option1",
            value: 1,
          },
        ],
        radios_bangla: [
          {
            title: "অপশন১",
            value: 1,
          },
        ],
        checkboxes: [
          {
            title: "option1",
            value: 1,
          },
        ],
        checkboxes_bangla: [
          {
            title: "অপশন১",
            value: 1,
          },
        ],
        dropdowns: [
          {
            title: "option1",
            value: 1,
          },
        ],
        dropdowns_bangla: [
          {
            title: "অপশন১",
            value: 1,
          },
        ],
        images: [
          {
            url: "",
            id: "",
            value: 1,
            name: "",
          },
        ],
        range: {
          min: "",
          max: "",
        },
        slider: {
          min: "",
          max: "",
          interval: "",
        },
        starRating: {
          min: 1,
          max: "",
        },
        contactInfo: {
          first_name: true,
          middle_name: true,
          last_name: false,
          phone: true,
          email: true,
          address: false,
        },
        openEnded: {
          text_type: "",
          condition: "",
          conditional_number: "",
          conditional_text: "",
          custom_error: "",
        },
      });
      if (this.questionData.questions.length > 1) {
        this.questionData.current_question_id = parseInt(
          this.questionData.current_question_id + 1
        );
      } else {
        this.questionData.current_question_id = 1;
      }
      this.questionData.questions[
        this.questionData.questions.length - 1
      ].question_variable = "var" + this.questionData.current_question_id;
      this.activeIndex = this.questionData.questions.length - 1;
    },
    // calculate price with question type
    calculatedPrice(event, counter) {
      // console.log(this.questionData);
      this.questionData.ui_category_price[counter] =
        this.indexData.uiCategories[event - 1].price;
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (!/^[A-Za-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    deleteQuestion(counter) {
      this.questionData.questions.splice(counter, 1);
      this.questionData.ui_category_price.splice(counter, 1);
    },
    addOption(counter) {
      var radios_length =
        this.questionData.questions[counter].radios.length + 1;
      this.questionData.questions[counter].radios.push({
        title: "option",
        value: radios_length,
      });
    },
    deleteOption(counter, index) {
      if (this.validateOptionDelete(counter)) {
        alert(
          "You can't delete this options. Because you use these options as logic in next question"
        );
      } else {
        this.questionData.questions[counter].radios.splice(index, 1);

        this.questionData.questions[counter].radios.forEach((element, i) => {
          this.questionData.questions[counter].radios[i].id = i + 1;
        });
      }
    },

    addOptionBangla(counter) {
      var radios_length =
        this.questionData.questions[counter].radios_bangla.length + 1;
      this.questionData.questions[counter].radios_bangla.push({
        title: "অপশন",
        value: radios_length,
      });
    },
    deleteOptionBangla(counter, index) {
      if (this.validateOptionDelete(counter)) {
        alert(
          "You can't delete this options. Because you use these options as logic in next question"
        );
      } else {
        this.questionData.questions[counter].radios_bangla.splice(index, 1);

        this.questionData.questions[counter].radios_bangla.forEach(
          (element, i) => {
            this.questionData.questions[counter].radios_bangla[i].id = i + 1;
          }
        );
      }
    },
    addBothOption(counter) {
      var radios_length =
        this.questionData.questions[counter].radios.length + 1;
      this.questionData.questions[counter].radios.push({
        title: "option",
        value: radios_length,
      });
      this.questionData.questions[counter].radios_bangla.push({
        title: "অপশন",
        value: radios_length,
      });
    },
    validateOptionDelete(counter) {
      var counter_variable =
        this.questionData.questions[counter].question_variable;
      var isMatch = false;
      for (var i = counter + 1; i < this.questionData.questions.length; i++) {
        // console.log(this.questionData.questions[i].logic_variables);
        this.questionData.questions[i].logic_variables.forEach((element) => {
          if (element.var_name == counter_variable) {
            // console.log("match");
            isMatch = true;
          }
        });
      }
      return isMatch;
    },
    deleteBothOption(counter, index) {
      // console.log(this.questionData.questions[counter].radios_bangla);
      if (this.validateOptionDelete(counter)) {
        alert(
          "You can't delete this options. Because you use these options as logic in next question"
        );
      } else {
        this.questionData.questions[counter].radios.splice(index, 1);
        this.questionData.questions[counter].radios_bangla.splice(index, 1);

        this.questionData.questions[counter].radios_bangla.forEach(
          (element, i) => {
            this.questionData.questions[counter].radios[i].id = i + 1;
            this.questionData.questions[counter].radios_bangla[i].id = i + 1;
          }
        );
      }
    },

    addCheckbox(counter) {
      var checkboxes_length =
        this.questionData.questions[counter].checkboxes.length + 1;
      this.questionData.questions[counter].checkboxes.push({
        title: "option",
        value: checkboxes_length,
      });
    },

    deleteCheckbox(counter, index) {
      if (this.validateOptionDelete(counter)) {
        alert(
          "You can't delete this options. Because you use these options as logic in next question"
        );
      } else {
        this.questionData.questions[counter].checkboxes.splice(index, 1);

        this.questionData.questions[counter].checkboxes.forEach(
          (element, i) => {
            this.questionData.questions[counter].checkboxes[i].id = i + 1;
          }
        );
      }
    },

    addCheckboxBangla(counter) {
      var checkboxes_length =
        this.questionData.questions[counter].checkboxes_bangla.length + 1;
      this.questionData.questions[counter].checkboxes_bangla.push({
        title: "অপশন",
        value: checkboxes_length,
      });
    },

    deleteCheckboxBangla(counter, index) {
      if (this.validateOptionDelete(counter)) {
        alert(
          "You can't delete this options. Because you use these options as logic in next question"
        );
      } else {
        this.questionData.questions[counter].checkboxes_bangla.splice(index, 1);

        this.questionData.questions[counter].checkboxes_bangla.forEach(
          (element, i) => {
            this.questionData.questions[counter].checkboxes_bangla[i].id =
              i + 1;
          }
        );
      }
    },

    addBothCheckbox(counter) {
      var checkboxes_length =
        this.questionData.questions[counter].checkboxes_bangla.length + 1;
      this.questionData.questions[counter].checkboxes.push({
        title: "option",
        value: checkboxes_length,
      });
      this.questionData.questions[counter].checkboxes_bangla.push({
        title: "অপশন",
        value: checkboxes_length,
      });
    },

    deleteBothCheckbox(counter, index) {
      if (this.validateOptionDelete(counter)) {
        alert(
          "You can't delete this options. Because you use these options as logic in next question"
        );
      } else {
        this.questionData.questions[counter].checkboxes.splice(index, 1);
        this.questionData.questions[counter].checkboxes_bangla.splice(index, 1);

        this.questionData.questions[counter].checkboxes_bangla.forEach(
          (element, i) => {
            this.questionData.questions[counter].checkboxes[i].id = i + 1;
            this.questionData.questions[counter].checkboxes_bangla[i].id =
              i + 1;
          }
        );
      }
    },

    addDropDown(counter) {
      var dropdowns_length =
        this.questionData.questions[counter].dropdowns.length + 1;
      this.questionData.questions[counter].dropdowns.push({
        title: "option",
        value: dropdowns_length,
      });
    },

    deleteDropDown(counter, index) {
      if (this.validateOptionDelete(counter)) {
        alert(
          "You can't delete this options. Because you use these options as logic in next question"
        );
      } else {
        this.questionData.questions[counter].dropdowns.splice(index, 1);

        this.questionData.questions[counter].dropdowns.forEach((element, i) => {
          this.questionData.questions[counter].dropdowns[i].id = i + 1;
        });
      }
    },

    addDropDownBangla(counter) {
      var dropdowns_length =
        this.questionData.questions[counter].dropdowns_bangla.length + 1;
      this.questionData.questions[counter].dropdowns_bangla.push({
        title: "অপশন",
        value: dropdowns_length,
      });
    },

    deleteDropDownBangla(counter, index) {
      if (this.validateOptionDelete(counter)) {
        alert(
          "You can't delete this options. Because you use these options as logic in next question"
        );
      } else {
        this.questionData.questions[counter].dropdowns_bangla.splice(index, 1);

        this.questionData.questions[counter].dropdowns_bangla.forEach(
          (element, i) => {
            this.questionData.questions[counter].dropdowns_bangla[i].id = i + 1;
          }
        );
      }
    },
    addBothDropDown(counter) {
      var dropdowns_length =
        this.questionData.questions[counter].dropdowns.length + 1;
      this.questionData.questions[counter].dropdowns.push({
        title: "option",
        value: dropdowns_length,
      });
      this.questionData.questions[counter].dropdowns_bangla.push({
        title: "অপশন",
        value: dropdowns_length,
      });
    },
    deleteBothDropDown(counter, index) {
      if (this.validateOptionDelete(counter)) {
        alert(
          "You can't delete this options. Because you use these options as logic in next question"
        );
      } else {
        this.questionData.questions[counter].dropdowns_bangla.splice(index, 1);
        this.questionData.questions[counter].dropdowns.splice(index, 1);

        this.questionData.questions[counter].dropdowns_bangla.forEach(
          (element, i) => {
            this.questionData.questions[counter].dropdowns[i].id = i + 1;
            this.questionData.questions[counter].dropdowns_bangla[i].id = i + 1;
          }
        );
      }
    },
    addImage(counter) {
      this.questionData.questions[counter].images.push({
        url: "",
        id: "",
        name: "",
      });
    },
    deleteImage(counter, index) {
      const token = window.localStorage.getItem("datadash_token");
      if (this.questionData.questions[counter].images[index].id) {
        if (token != null) {
          axios
            .post(
              `${api.rootUrl}/${"delete-option-image"}`,
              this.questionData.questions[counter].images[index],
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              if (response.data.data.success == 1) {
                this.questionData.questions[counter].images.splice(index, 1);
              }
            });
        }
      } else {
        this.questionData.questions[counter].images.splice(index, 1);
      }
    },
    listItem(counter, index) {
      // console.log(counter,index)
      if (index == 0) {
        this.questionData.questions[counter].instruction = "";
        this.questionData.questions[counter].boolean1 =
          !this.questionData.questions[counter].boolean1;
      } else {
        this.questionData.questions[counter].description = "";
        this.questionData.questions[counter].boolean2 =
          !this.questionData.questions[counter].boolean2;
      }
    },
    onImageChange(file, counter, index) {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          // convert image file to base64 string
          let str = reader.result;
          let res = str.split(",");
          // console.log(res);
          this.questionData.questions[counter].images[index].url = res[1];
        }.bind(this),
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
      setTimeout(() => {
        this.uploadOptionImage(counter, index);
      }, 600);
      // console.log(file);
    },

    uploadOptionImage(counter, index) {
      if (
        typeof this.questionData.questions[counter].images[index].id ===
        "undefined"
      ) {
        this.questionData.questions[counter].images[index].id = null;
      }
      var imageData = {
        imageInfo: this.questionData.questions[counter].images[index],
        project_id: this.indexData.project_data.id,
      };
      // console.log(imageData);
      if (this.questionData.questions[counter].images[index].url) {
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
            axios
              .post(`${api.rootUrl}/${"option-image"}`, imageData, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                // console.log(response);
                if (response.data.data.datas.id != "") {
                  this.questionData.questions[counter].images[index].id =
                    response.data.data.datas.id;
                  this.questionData.questions[counter].images[index].url =
                    response.data.data.datas.url;
                }
              });
          }
        } catch (error) {
          this.indexData.error = error;
          this.x = "right";
          this.snackbar = true;
          this.close();
        }
      }
      // console.log(this.questionData.questions[counter].images);
    },

    isLetterForImage(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[_A-Za-z0-9]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },

    imageValidationCheck(event, activeIndex, index) {
      var match_index = true;
      this.questionData.questions[activeIndex].images.forEach((element, i) => {
        if (event === element.name && i !== index) {
          match_index = false;
        }
      });
      if (!match_index) {
        return `Image name must be unique for a question`;
      } else {
        return match_index;
      }
    },
    // date time type question
    onDateChange(event, counter) {
      if (event == "date") {
        this.questionData.questions[counter].date_time = "date";
      } else if (event == "time") {
        this.questionData.questions[counter].date_time = "time";
      } else {
        this.questionData.questions[counter].date_time = "date & time";
      }
    },
    onOpenEndedValidation(event, counter) {
      // console.log(event.text_type);
      // console.log(counter);
      if (event.text_type) {
        this.questionData.questions[counter].openEnded.text_type =
          event.text_type;
      }
      if (event.condition) {
        this.questionData.questions[counter].openEnded.condition =
          event.condition;
      }
      if (event.conditional_number) {
        this.questionData.questions[counter].openEnded.conditional_number =
          event.conditional_number;
      }
      if (event.conditional_text) {
        this.questionData.questions[counter].openEnded.conditional_text =
          event.conditional_text;
      }
      if (event.custom_error) {
        this.questionData.questions[counter].openEnded.custom_error =
          event.custom_error;
      }
      // console.log(this.questionData.questions[counter].openEnded);
    },
    // contact info type
    contactInfo(event, counter) {
      // console.log(event);
      var num_value = +event;
      if (event !== "" && !isNaN(num_value)) {
        if (event == 1) {
          this.questionData.questions[counter].contactInfo.first_name = false;
        } else if (event == 2) {
          this.questionData.questions[counter].contactInfo.middle_name = false;
        } else if (event == 3) {
          this.questionData.questions[counter].contactInfo.last_name = false;
        } else if (event == 4) {
          this.questionData.questions[counter].contactInfo.phone = false;
        } else if (event == 5) {
          this.questionData.questions[counter].contactInfo.email = false;
        } else if (event == 6) {
          this.questionData.questions[counter].contactInfo.first_name = true;
          this.questionData.questions[counter].error_message = "";
        } else if (event == 7) {
          this.questionData.questions[counter].contactInfo.middle_name = true;
          this.questionData.questions[counter].error_message = "";
        } else if (event == 8) {
          this.questionData.questions[counter].contactInfo.last_name = true;
          this.questionData.questions[counter].error_message = "";
        } else if (event == 9) {
          this.questionData.questions[counter].contactInfo.phone = true;
          this.questionData.questions[counter].error_message = "";
        } else {
          this.questionData.questions[counter].contactInfo.email = true;
          this.questionData.questions[counter].error_message = "";
        }
      } else {
        if (event == "add") {
          this.questionData.questions[counter].contactInfo.address = true;
          this.questionData.questions[counter].error_message = "";
        } else {
          this.questionData.questions[counter].contactInfo.address = false;
        }
      }
    },
    // calculate sum of total question price
    totalCategoryPrice() {
      var i;
      this.questionData.total_category_price = 0;
      for (i = 0; i < this.questionData.ui_category_price.length; i++) {
        this.questionData.total_category_price +=
          this.questionData.ui_category_price[i];
      }
      localStorage.setItem(
        "total_Editing_question_price",
        this.questionData.total_category_price
      );
      localStorage.setItem(
        "editingQuestionPriceArray",
        JSON.stringify(this.questionData.ui_category_price)
      );
    },
    questionValidation() {
      var error_case = 0;
      for (var i = 0; i < this.questionData.questions.length; i++) {
        if (this.questionData.questions[i].ui_category_id == 15) {
          if (
            !(
              this.questionData.questions[i].contactInfo.first_name ||
              this.questionData.questions[i].contactInfo.middle_name ||
              this.questionData.questions[i].contactInfo.last_name ||
              this.questionData.questions[i].contactInfo.email ||
              this.questionData.questions[i].contactInfo.phone ||
              this.questionData.questions[i].contactInfo.address
            )
          ) {
            error_case = error_case + 1;
            this.questionData.questions[i].error_message =
              "This field is required";
          } else {
            this.questionData.questions[i].error_message = "";
          }
          //
        }
      }
      if (error_case > 0) {
        // console.log("false");
        return false;
      } else {
        //  console.log("true" + error_case);
        return true;
      }
    },
    back() {
      var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
      if (this.indexData.project_data.project_type_id == 2) {
        this.$store.dispatch("indexDataAndRout", [
          "response-location",
          project_id,
          "/edit-address",
        ]);
      } else {
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          project_id,
          "/edit-project",
        ]);
      }
    },
    assignTeamToProject() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "project-dasher-category",
        project_id,
        "/edit-assign-teams-to-Project",
      ]);
    },
    locationPage() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "response-location",
        project_id,
        "/edit-address",
      ]);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    copyQuestionsFromProject() {
      this.dialog2 = true;
      // this.snackbar = true;
      // this.close();
    },
    isLanguageBangla(language_id) {
      if (parseInt(language_id) == 2 || parseInt(language_id) == 3) {
        return true;
      } else {
        return false;
      }
    },
    isLanguageEnglish(language_id) {
      if (parseInt(language_id) == 1 || parseInt(language_id) == 3) {
        return true;
      } else {
        return false;
      }
    },

    onclickCopyQuestions(event) {
      if (event) {
        event.forEach((element) => {
          this.questionData.questions.push({
            question: element.question,
            question_variable: "",
            question_bangla: element.question_bangla,
            ui_category_id: element.ui_category_id,
            required_optional: element.required_optional,
            multiple_answer: element.multiple_answer,
            instruction: element.instruction?element.instruction.instruction:null,
            instruction_bangla: element.instruction_bangla?element.instruction_bangla.instruction:null,
            description: element.description?element.description.description:null,
            description_bangla: element.description_bangla?element.description_bangla.description:null,
            error_message: "",
            boolean1: false,
            boolean2: false,
            has_logic: false,
            date_time: "date & time",
            child_variables: [],
            logic_variables: [],
            logic_group: [
              {
                logic_set: [
                  {
                    q_index: "",
                    logic_operator_id: "",
                    logic_input: "",
                    logic_condition: "",
                    logic_input_ui_type: "",
                    logic_operator: [],
                  },
                ],
              },
            ],
            radios:
              element.ui_category_id == 1 &&
              this.isLanguageEnglish(element.project_language) &&
              element.options.length > 0
                ? element.options
                : [
                    {
                      title: "option1",
                      value: 1,
                    },
                  ],
            radios_bangla:
              element.ui_category_id == 1 &&
              this.isLanguageBangla(element.project_language) &&
              element.bangla_options.length > 0
                ? element.bangla_options
                : [
                    {
                      title: "অপশন১",
                      value: 1,
                    },
                  ],
            checkboxes:
              element.ui_category_id == 2 &&
              this.isLanguageEnglish(element.project_language) &&
              element.options.length > 0
                ? element.options
                : [
                    {
                      title: "option1",
                      value: 1,
                    },
                  ],
            checkboxes_bangla:
              element.ui_category_id == 2 &&
              this.isLanguageBangla(element.project_language) &&
              element.bangla_options.length > 0
                ? element.bangla_options
                : [
                    {
                      title: "অপশন১",
                      value: 1,
                    },
                  ],
            dropdowns:
              element.ui_category_id == 4 &&
              this.isLanguageEnglish(element.project_language) &&
              element.options.length > 0
                ? element.options
                : [
                    {
                      title: "option1",
                      value: 1,
                    },
                  ],
            dropdowns_bangla:
              element.ui_category_id == 4 &&
              this.isLanguageBangla(element.project_language) &&
              element.bangla_options.length > 0
                ? element.bangla_options
                : [
                    {
                      title: "অপশন১",
                      value: 1,
                    },
                  ],
                  
            images: [
              {
                url: element.imageOptions.url || "",
                id: element.imageOptions.id || "",
                value: 1,
                name: element.imageOptions.name || "",
              },
            ],

            range: {
              min: element.option_val ? element.option_val.min_value || "" : "",
              max: element.option_val ? element.option_val.max_value || "" : "",
            },

            slider: {
              min: element.option_val ? element.option_val.min_value || "" : "",
              max: element.option_val ? element.option_val.max_value || "" : "",
              interval: element.option_val
                ? element.option_val.interval || ""
                : "",
            },

            starRating: {
              min: element.option_val ? element.option_val.min_value || 1 : 1,
              max: element.option_val ? element.option_val.max_value || "" : "",
            },
            contactInfo: {
              first_name: true,
              middle_name: true,
              last_name: false,
              phone: true,
              email: true,
              address: false,
            },
            openEnded: {
              text_type: "",
              condition: "",
              conditional_number: "",
              conditional_text: "",
              custom_error: "",
            },
          });
          if (this.questionData.questions.length > 1) {
            this.questionData.current_question_id = parseInt(
              this.questionData.current_question_id + 1
            );
            this.questionData.ui_category_price[
              this.questionData.current_question_id
            ] = this.indexData.uiCategories[element.ui_category_id - 1].price;
          } else {
            this.questionData.current_question_id = 1;
            this.questionData.ui_category_price[
              this.questionData.current_question_id
            ] = this.indexData.uiCategories[element.ui_category_id - 1].price;
          }
          this.questionData.questions[
            this.questionData.questions.length - 1
          ].question_variable = "var" + this.questionData.current_question_id;
        });
        this.dialog2 = false;
      } else {
        this.dialog2 = false;
      }
    },

    hasConditionalQuestionAllowed() {
      if (utilities.clientId()) {
        return true;
      }
      if (
        utilities.conditionalQuestionAllowed(
          this.subscriptionData.subscriptionFeatures
        )
      ) {
        return true;
      }
      return false;
    },

    submit() {
      if (this.$refs.form.validate() == true && this.questionValidation()) {
        this.totalCategoryPrice();
        this.QuestSubmitData.data = this.questionData;
        this.$store.dispatch("storeOrUpdateQuestionModify", [
          "project-question-modify",
          this.QuestSubmitData,
        ]);
      }
      this.snackbar = true;
      this.close();
    },
  },
};
</script>
<style>
.ck.ck-editor__editable:not(.ck-editor__nested-editable) {
  border-radius: 0;
  min-height: 100px;
}
.ck-content {
  min-height: 100px;
}
.question-layout {
  min-width: 500px;
}
</style>
<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}

.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 30px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.i_button {
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  text-transform: none !important;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}

.list-color-active {
  background: #ff2e2e;
  border-radius: 5px;
  margin-bottom: 2px;
  color: white;
}
.tool-bar-tab {
  background: white;
  margin-top: 2px;
}
.scrollable {
  max-height: 500px; /* or any height you want */
  min-height: 50px; /* or any height you want */
  overflow-y: auto;
}
</style>
